import { useQuery } from 'react-query';

import { ForumPostOptions, ForumPostsResult, getForumPosts } from '@utils/backend-api/forumPosts';
import {
  SubscriberDirectoryParams,
  SubscriberDirectoryResponse,
  getSubscriberDirectory,
} from '@utils/backend-api/subscriber_directory';

export const SEARCH_RESULTS_KEY = 'SEARCH_RESULTS_KEY';

export enum SearchScope {
  Articles = 'articles',
  Forum = 'forum',
  Directory = 'directory',
}

const RESULTS_PER_PAGE = 20;
const API_METHODS = {
  [SearchScope.Forum]: getForumPosts,
  [SearchScope.Directory]: getSubscriberDirectory,
};

export default function useSearchResults(page: number, query: string, scope: SearchScope) {
  let searchApiParams: ForumPostOptions | SubscriberDirectoryParams;
  if (scope === SearchScope.Forum) {
    searchApiParams = {
      onSearchPage: true,
      page,
      perPage: RESULTS_PER_PAGE,
      topic: query.toLowerCase(),
    };
  } else if (scope === SearchScope.Directory) {
    searchApiParams = {
      ai_query: query,
    };
  }
  const { data, isLoading } = useQuery<ForumPostsResult | SubscriberDirectoryResponse>(
    [SEARCH_RESULTS_KEY, scope, searchApiParams],
    () => {
      const apiMethod = API_METHODS[scope];
      if (apiMethod) return apiMethod(searchApiParams);
    },
    { keepPreviousData: true }
  );

  return { data, isLoading };
}
